import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


/**
 * Base UI Components to be imported, 
 * this mandatory to be included so that the View Module Pages can be rendered via baseUI
 */
import { BaseUIContainerComponent } from '../../BaseFramework/base-ui/base-ui-container/base-ui-container.component'
import { AppLayoutComponent } from '../../BaseFramework/base-ui/app-layout/app-layout.component'
import { ClaimsAuthenticationGuard } from '../Claims';
////BASEUI Modules End

// import { NBCaptureProposalComponent } from './nb-capture-proposal/nb-capture-proposal.component';



var subroutes = [
    // {
    //     path: 'nb-capture-proposal',
    //     component: NBCaptureProposalComponent,
    //     data: {
    //         breadcrumb: 'Capture Proposal'
    //     },
    // },
    // { path: 'proposal', loadChildren: './proposal/newproposal.module#NewProposalModule' },
    // { path: 'transaction', loadChildren: './transaction-proposal/transaction-proposal.module#TransactionProposalModule' }

];

const routes: Routes = [
    {
        path: '',
        component: BaseUIContainerComponent,
        children: [

            {
                path: 'app/nbu',
                component: AppLayoutComponent,
                canActivate: [ClaimsAuthenticationGuard],
                children: [
                    ...subroutes
                ]
            },


        ]
    },
    { path: 'proposal', loadChildren: () => import('./proposal/newproposal.module').then(m => m.NewProposalModule) },
    { path: 'transaction', loadChildren: () => import('./transaction/transaction.module').then(m => m.TransactionNBUModule) },
    { path: 'inbox', loadChildren: () => import('./inbox/inbox.module').then(m => m.InboxUWModule) },
    // { path: 'proposal', loadChildren: './proposal/newproposal.module#NewProposalModule' },
    // { path: 'registration', loadChildren: './registration/registration.module#RegistrationModule' },
    // { path: 'inbox', loadChildren: './inbox/inbox.module#InboxModule' },

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: []
})

export class NewBusinessRoutingModule { }
